import App from '~/src/pages/_app/_app';

// global font includes are only possible in pages/_app.js
import 'normalize.css/normalize.css';
import '~/src/css/_fonts.scss';
import '~/src/css/base.scss';

export default App;
